import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { FormGroup } from '@angular/forms';
import { Auth } from '../../../../autentication/Auth';
import { AutenticationService } from '../../../../autentication/autentication.service';
import { PixRefundService } from '../refund.service';
import { EventTypes } from '../../../../shared/EventTypes';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';
import { Util } from '../../../../utils/util';
import { PixDevolutionRequest } from '../../models/devolution-request.mode';
import { PixTransferReturn, PixTransferReturnSituacaoTransferencia, PixTransferReturnSucesso } from '../../models/transfer-return.model';
import { PixPaymentKeyFavoredCreateDetailComponent } from '../../payment-key/favored-create/details/details.component';
import { SharedModalInfoComponent } from '../../../../shared/modal-info/modal-info.component';
import { PixReceipt } from '../../models/receipt.model';
import { PixPaymentKeyService } from '../../payment-key/payment-key.service';
import { PixTransaction } from '../../models/transaction.model';

@Component({
	selector: 'app-pix-payment-refund-assignature',
	templateUrl: './assignature.component.html',
	styleUrls: ['./assignature.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixRefundAssignatureComponent implements OnInit {

	public submited = false;
	public form: FormGroup;
	public guid = '';
	private pixDevolutionRequest: PixDevolutionRequest;
	private pixTransactionToRefund: PixTransaction;

	constructor(
		private autenticationService: AutenticationService,
		private router: Router,
		public dialog: MatDialog,
		private pixRefundService: PixRefundService,
		private pixPaymentKeyService: PixPaymentKeyService
	) { }

	ngOnInit() {

		this.pixDevolutionRequest = this.pixRefundService.getPixDevolutionRequest();
		this.pixTransactionToRefund = this.pixRefundService.getPixTransaction();
		console.log(this.pixDevolutionRequest);
		console.log('click: ', this.pixTransactionToRefund);
		this.guid = Util.generateGUID();

		if (this.invalidParams()) {
			this.goBack();
		}
	}

	invalidParams(): boolean {
		return this.pixDevolutionRequest === undefined || this.pixDevolutionRequest.codigoTransacao === undefined || this.pixDevolutionRequest.valor === undefined;
	}

	submit(message: boolean) {
		this.submited = message;

		if (this.submited && this.form.valid) {
			this.addAuthToken();
			this.sendAssignature();
		}
	}

	addAuthToken() {
		if (this.form.value.token) {
			Auth.passToken = this.form.value.token;
		}
	}

	addAuthSignature() {
		if (this.form.value.eletronicSignature) {
			Auth.assinaturaEletronica = this.form.value.eletronicSignature;
		}
	}

	sendAssignature() {
		this.autenticationService.sendDigitalSignature(this.form.value.eletronicSignature).subscribe(data => {
			if (data.Sucesso) {
				this.addAuthSignature();
				this.sendRequest();
			}
		}, error => {
			this.handleError(error);
		});
	}

	sendRequest() {
		this.pixDevolutionRequest.codigoRequisicao = this.guid;

		this.pixRefundService.postDevolution(this.pixDevolutionRequest).subscribe(data => {
			if (data.Sucesso) {
				const result = Util.keysToCamel(data.Retorno) as PixTransferReturn;
				this.processResult(result);
			}
		}, error => {
			this.handleError(error);
		});
	}

	processResult(result: PixTransferReturn) {
		console.log(result);
		switch (result.situacaoTransferencia) {
			case PixTransferReturnSituacaoTransferencia.AGUARDANDO_AUTORIZACAO:
				this.generateReceiptScheduled(false);
				this.dialog.open(PixPaymentKeyFavoredCreateDetailComponent, { width: '400px', data: {
					situacaoTransferencia: result.situacaoTransferencia,
					nome: this.pixDevolutionRequest.nome,
					valor: this.pixDevolutionRequest.valor,
					dataContabil: this.pixDevolutionRequest.dataAgendamento,
					complemento: this.pixDevolutionRequest.descricao
				}}).afterClosed().subscribe(result => {
					if (result === undefined) {
						this.router.navigate(['pix']);
					}
				});
				break;
			case PixTransferReturnSituacaoTransferencia.AUTORIZADA_AGUARDANDO_EFETIVACAO:
				this.generateReceiptScheduled(true);
				this.dialog.open(PixPaymentKeyFavoredCreateDetailComponent, { width: '400px', data: {
					situacaoTransferencia: result.situacaoTransferencia,
					nome: this.pixDevolutionRequest.nome,
					valor: this.pixDevolutionRequest.valor,
					dataContabil: this.pixDevolutionRequest.dataAgendamento,
					complemento: this.pixDevolutionRequest.descricao
				}}).afterClosed().subscribe(result => {
					if (result === undefined) {
						this.router.navigate(['pix']);
					}
				});
				break;
			case PixTransferReturnSituacaoTransferencia.TRANSFERENCIA_REALIZADA:
				this.generateAndGoToReceipt(result.sucesso);
				break;
			case PixTransferReturnSituacaoTransferencia.AGUARDANDO_CONFIRMACAO_IF_DESTINO:
				this.openModal(
					'Estamos processando essa transação',
					'Essa transação esta demorando um pouco mais que o normal',
					'Assim que ela for concluída, ele estará disponível no Extrato. Caso contrário, consulte o item em Transações não realizadas no menu Transações',
					'Entendi');
				break;
				case PixTransferReturnSituacaoTransferencia.TRANSFERENCIA_REPROVADA:
					this.openModal('Transação não concluída', '', result.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.TRANSFERENCIA_EXPIRADA:
					this.openModal('Transação não concluída', '', result.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.ERRO_TRANSFERENCIA:
					this.openModal('Transação não concluída', '', result.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.REJEITADA_IF_DESTINO:
					this.openModal('Transação não concluída', '', result.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.CANCELADA_TESOURARIA:
					this.openModal('Transação não concluída', '', result.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.CANCELADA_CLIENTE:
					this.openModal('Transação não concluída', '', result.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.AGUARDANDO_ANALISE_ANTIFRAUDE:
					this.openModal(
					'Estamos processando essa transação',
					'Essa transação esta demorando um pouco mais que o normal',
					'Assim que ela for concluída, ele estará disponível no Extrato. Caso contrário, consulte o item em Transações não realizadas no menu Transações',
					'Entendi');
				break;
			default:
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Houve uma falha na conexão de internet. Por favor tente novamente.' });
				break;
		}
	}

	generateAndGoToReceipt(ret: PixTransferReturnSucesso) {
		this.router.navigate(['pix/comprovante/' + ret.codigoTransacao + '/pix']);
	}

	openModal(title: string, topText: string, text: string, btnName = 'Fechar', btnBackName = '') {
		const dialogRef = this.dialog.open(SharedModalInfoComponent, {
			width: '420px',
			data: {
				title: title,
				topText: topText,
				text: text,
				btnName: btnName,
				btnBackName: btnBackName
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			this.router.navigate(['pix']);
		});
	}

	generateReceiptScheduled(authorized: boolean) {
		const model = new PixReceipt();

		model.agendado = authorized;
		model.authorized = authorized;
		model.nome = this.pixDevolutionRequest.nome;
		model.dataContabil = new Date();
		model.valor = this.pixDevolutionRequest.valor;
		model.complemento = this.pixDevolutionRequest.descricao;
		model.iSPBNome = this.pixTransactionToRefund.advanced.transacaoPix.nomeISPB;
		model.agencia = this.pixTransactionToRefund.advanced.transacaoPix.agencia;
		model.numeroConta = this.pixTransactionToRefund.advanced.transacaoPix.numeroConta.toString();
		model.tipoConta = this.pixTransactionToRefund.advanced.transacaoPix.tipoConta;
		model.documento = Util.removeNonNumerics(this.pixTransactionToRefund.advanced.transacaoPix.documento);

		this.pixPaymentKeyService.setSelectedPixReceipt(model);
	}

	goNext = () => this.router.navigate(['pix/devolver/comprovante']);
	handleError = (error) => AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
	goBack = () => this.router.navigate(['pix/devolver/valor']);
	onSetSignatureForm = (form: FormGroup) => this.form = form;

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/refund/assignature/assignature.component.ts